import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'

import NavBarContainer from './../../containers/NavBarContainer'
import MenuContainer from './../../containers/MenuContainer'
import ContactContainer from './../../containers/ContactContainer'
import DialogContainer from './../../containers/DialogContainer'

import Home from './Home'
import Adoption from './Adoption'
import Books from './Books'

const Landing = () => {
  return (
    <div className='route route--landing'>
      <NavBarContainer />
      <MenuContainer />
      <Switch>
        <Route path='/' component={Home} exact />
        <Route path='/adoption' component={Adoption} />
        <Route path='/adoption_send' component={Adoption} />
        <Route path='/adoption_send_product' component={Adoption} />
        <Route path='/books' component={Books} />
        <Route path='/contact_inner' component={ContactContainer} />
      </Switch>
      <DialogContainer />
    </div>
  )
}

Landing.propTypes = {
  logout: PropTypes.func
}

export default Landing



// WEBPACK FOOTER //
// ./src/routes/Landing/index.js